export class DestinationRestoreTypeAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "objectStorage",
            "baseName": "objectStorage",
            "type": "ObjectStorageDestination",
            "format": ""
        },
        {
            "name": "azureVm",
            "baseName": "azureVm",
            "type": "VirtualMachineRestoreDestination",
            "format": ""
        },
        {
            "name": "dynamoDbTable",
            "baseName": "dynamoDbTable",
            "type": "AwsDynamoDBDestination",
            "format": ""
        },
        {
            "name": "eksNamespace",
            "baseName": "eksNamespace",
            "type": "EksNamespaceRestoreDestination",
            "format": ""
        },
        {
            "name": "rdsInstance",
            "baseName": "rdsInstance",
            "type": "AwsDatabaseDestination",
            "format": ""
        },
        {
            "name": "neptune",
            "baseName": "neptune",
            "type": "NeptuneRestoreDestination",
            "format": ""
        },
        {
            "name": "documentdb",
            "baseName": "documentdb",
            "type": "DocumentDBRestoreDestination",
            "format": ""
        },
        {
            "name": "redshift",
            "baseName": "redshift",
            "type": "RedshiftRestoreDestination",
            "format": ""
        },
        {
            "name": "efs",
            "baseName": "efs",
            "type": "EFSRestoreDestination",
            "format": ""
        },
        {
            "name": "fsx",
            "baseName": "fsx",
            "type": "FSxRestoreDestination",
            "format": ""
        },
        {
            "name": "gcpCloudSql",
            "baseName": "gcpCloudSql",
            "type": "GcpCloudSqlTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DestinationRestoreTypeAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
